import { AxiosInstance } from "axios";
import type {
  OrgSelectionApi,
  SelectOrgRequest,
  SourceOrg,
} from "../source-settings/OrgSelection.types";
import type {
  AltusProject,
  AltusProjectBucket,
} from "./AltusSourceSettings.types";

export class AltusSourceSettingsApi implements OrgSelectionApi {
  constructor(private readonly client: AxiosInstance) {}

  /**
   * Environments (organisations) the connection's discovery token can see.
   * Only meaningful between the first OAuth leg and org selection.
   */
  async getOrgs(boardId: string, connectionId: string): Promise<SourceOrg[]> {
    const response = await this.client.get<SourceOrg[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/altus/orgs`,
    );
    return response.data;
  }

  /**
   * Save the chosen environment against the connection.
   * Returns the provider auth URL for the second, environment-scoped OAuth leg.
   */
  async selectOrg(
    boardId: string,
    connectionId: string,
    request: SelectOrgRequest,
  ): Promise<{ authUrl: string }> {
    const response = await this.client.post<{ authUrl: string }>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/altus/select-org`,
      request,
    );
    return response.data;
  }

  async getProjects(
    boardId: string,
    connectionId: string,
    searchTerm: string,
  ): Promise<AltusProject[]> {
    const response = await this.client.get<AltusProject[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/altus/projects?searchTerm=${encodeURIComponent(searchTerm)}`,
    );
    return response.data;
  }

  async getProjectBuckets(
    boardId: string,
    connectionId: string,
    projectId: string,
  ): Promise<AltusProjectBucket[]> {
    const response = await this.client.get<AltusProjectBucket[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/altus/projects/${encodeURIComponent(projectId)}/buckets`,
    );
    return response.data;
  }
}
